import lazyLoading from './lazyLoading'
import Global from '../../../services/globalservice'

export default {
  name: 'Holiday',
  meta: {
    icon: 'fa-clock-o',
    expanded: false,
    roles: Global.ALL_ROLE
  },

  children: [
    {
      name: 'Create Request',
      meta: {
        label: 'Create Request',
        roles: Global.ALL_ROLE
      },
      path: '/dayOff/request',
      component: lazyLoading('dayOff/RequestDayOff')
    },
    {
      name: 'My Request',
      path: '/dayOff/myRequest/:id',
      meta: {
        label: 'My Request',
        roles: Global.ALL_ROLE,
        link: '/dayOff/myRequest/'
      },
      component: lazyLoading('dayOff/MyRequest')
    },
    {
      name: 'Holiday Summary',
      meta: {
        label: 'Holiday Summary',
        roles: [Global.ROLE.ADMIN]
      },
      path: '/dayOff/summary',
      component: lazyLoading('dayOff/Summary')
    },
    {
      name: 'All Request',
      meta: {
        label: 'All Request',
        roles: [Global.ROLE.ADMIN]
      },
      path: '/dayOff/allRequest',
      component: lazyLoading('dayOff/AllRequest')
    },
    {
      name: 'Manager Request',
      meta: {
        label: 'Manager Request',
        roles: [Global.ROLE.GROUPMANAGER, Global.ROLE.ADMIN]
      },
      path: '/dayOff/managerRequest',
      component: lazyLoading('dayOff/ManagerRequest')
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/dayoff.js